import { useMemo } from 'react';
import { Breakpoint, useMediaQuery } from '@mui/material';

import type { ScreenSize } from '../themes/types';

export const useScreenSize = () => {
  const isXs = useMediaQuery((theme) => theme.breakpoints.only('xs'));
  const isSm = useMediaQuery((theme) => theme.breakpoints.only('sm'));
  const isMd = useMediaQuery((theme) => theme.breakpoints.only('md'));
  const isLg = useMediaQuery((theme) => theme.breakpoints.only('lg'));
  const isXl = useMediaQuery((theme) => theme.breakpoints.only('xl'));

  const isMobile = isXs;
  const isTablet = isSm;
  const isDesktop = isMd || isLg || isXl;

  const currentBreakpoint: Breakpoint = useMemo(() => {
    switch (true) {
      case isXs:
        return 'xs';
      case isSm:
        return 'sm';
      case isMd:
        return 'md';
      case isLg:
        return 'lg';
      case isXl:
        return 'xl';
      default:
        return 'lg';
    }
  }, [isXs, isSm, isMd, isLg, isXl]);

  const size: ScreenSize = useMemo(() => {
    if (isXs || isSm) {
      return 'small';
    }

    if (isMd || isLg) {
      return 'medium';
    }

    return 'large';
  }, [isXs, isSm, isMd, isLg]);

  return {
    currentBreakpoint,
    size,
    isXs,
    isSm,
    isMd,
    isLg,
    isXl,
    isMobile,
    isTablet,
    isDesktop,
  };
};
